import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	archivedError: {
		id: 'polaris-ideas.insights.insights.common.archived-error',
		defaultMessage: "You can't create an insight for an archived idea",
		description: 'Error message for creating an insight for an archived idea',
	},
});
